import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useOrderStatuses() {
  const orderStatuses = ref({});
  const orderStatus = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getOrderStatuses = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/order-statuses?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        orderStatuses.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getOrderStatus = async (id) => {
    axiosClient.get("/order-statuses/" + id).then((response) => {
      orderStatus.value = response.data.data;
    });
  };

  const storeOrderStatus = async (orderStatus) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedOrderStatus = new FormData();
    for (let item in orderStatus) {
      if (orderStatus.hasOwnProperty(item)) {
        serializedOrderStatus.append(item, orderStatus[item]);
      }
    }

    axiosClient
      .post("/order-statuses", serializedOrderStatus)
      .then((response) => {
        router.push({ name: "order-statuses.index" });
        swal({
          icon: "success",
          title: "order status saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateOrderStatus = async (orderStatus) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/order-statuses/" + orderStatus.id, orderStatus)
      .then((response) => {
        router.push({ name: "order-statuses.index" });
        swal({
          icon: "success",
          title: "Order status saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteOrderStatus = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/order-statuses/" + id)
          .then((response) => {
            getOrderStatuses();
            router.push({ name: "order-statuses.index" });
            swal({
              icon: "success",
              title: "Order status deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: error,
            });
          });
      }
    });
  };

  return {
    orderStatuses,
    orderStatus,
    getOrderStatuses,
    getOrderStatus,
    storeOrderStatus,
    validationErrors,
    isLoading,
    updateOrderStatus,
    deleteOrderStatus,
  };
}
